import { useDocumentVisibility, useRafInterval } from 'ahooks';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

export const RANGE_MINUTE = 10;
export const REFRESH_SECOND = RANGE_MINUTE * 60; // s 10分钟

export const RANGE_M_SECOND = REFRESH_SECOND * 1000; // ms 10分钟一次

interface IProps {
  start: boolean;
  execFun?: Function;
  timeout?: number;
}
/**
 * 续期刷新
 */
export const UseRefresh = (props: IProps) => {
  const { execFun, start = true, timeout = 0 } = props;
  const documentVisibility = useDocumentVisibility();
  const [time, setTime] = useState('');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(documentVisibility === 'visible');
  }, [documentVisibility]);

  const clear = useRafInterval(() => {
    if (visible && start) {
      execFun?.();
      setTime(dayjs().format('HH:mm:ss'));
    }
  }, (timeout * 1000) || RANGE_M_SECOND, { immediate: false });

  useEffect(() => () => {
    clear?.();
  }, [clear]);
  return { time };
};

export default UseRefresh;
